import React, { useEffect } from "react";
import styled from "@emotion/styled";

interface Props {
  hasCancel: boolean;
  title?: string;
  content: string;
  onOk: any;
  onClose?: any;
}

const PopupMini: React.FunctionComponent<Props> = ({
  title,
  content,
  hasCancel,
  onOk,
  onClose
}) => {
  useEffect(() => {
    function handleTouchWindow(e: any) {
      e.preventDefault();
    }

    document.body.classList.add("scrollHidden");
    window.addEventListener("touchmove", handleTouchWindow, {
      passive: false
    });

    return () => {
      document.body.classList.remove("scrollHidden");
      window.removeEventListener("touchmove", handleTouchWindow);
    };
  });

  return (
    <Dim id="jsDimMini">
      <Modal>
        <ModalInner>
          <div className="cell">
            {title && (
              <Header>
                <h3>{title}</h3>
              </Header>
            )}
            <div>
              <p>{content}</p>
            </div>
          </div>
        </ModalInner>
        <ButtonGroup>
          {hasCancel && (
            <button type="button" className="first" onClick={onClose}>
              취소
            </button>
          )}
          <button type="button" onClick={onOk}>
            확인
          </button>
        </ButtonGroup>
      </Modal>
    </Dim>
  );
};

const Dim = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
`;

const Modal = styled.div`
  overflow: hidden;
  position: relative;
  width: 360px;
  border-radius: ${props => props.theme.radius};
  background-color: ${props => props.theme.colors.white};
  text-align: center;
  font-size: ${props => props.theme.popup.sizeFont};
`;

const ModalInner = styled.div`
  display: table;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 140px;
  min-height: 140px;
  white-space: pre-line;

  .cell {
    display: table-cell;
    vertical-align: middle;
  }
`;

const Header = styled.header`
  margin-bottom: 12px;
  font-weight: ${props => props.theme.weight.bold};
  line-height: 1.53;
  letter-spacing: -0.28px;
`;

const ButtonGroup = styled.div`
  display: flex;

  button {
    flex: 1;
    position: relative;
    padding-left: 10px;
    padding-right: 10px;
    height: 50px;
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    font-weight: ${props => props.theme.weight.bold};

    &.first:after {
      content: "";
      position: absolute;
      top: 15px;
      right: 1px;
      display: block;
      width: 1px;
      height: 20px;
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
`;

export default PopupMini;
